<template>
  <div>
    
    <h1>Associação do Método com as Mobilidades</h1>

    <div class="container-dados-usuario pt-3" 
      v-if="!loadingTarefasMobilidades && listaDadosAssociados.length || listaDadosDisponiveis.length">
      <h5>Tarefa Origem: <small>{{ tarefaMobilidadeSelecionada.ctrl_tarefa_origem.tarefa }}</small> </h5>
      <h5>Tarefa Destino: <small>{{ tarefaMobilidadeSelecionada.ctrl_tarefa_destino.tarefa }}</small> </h5>
    </div>

    <div class="mcontainer-fluid">
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPAssociarComponent
            v-if="(listaDadosAssociados.length || listaDadosDisponiveis.length)"
            tituloAssociados="Métodos"
            tituloDisponiveis="Métodos"
            :dadoAssociado="listaDadosAssociados"
            :dadoDisponivel="listaDadosDisponiveis"
            @sgpSalvarAssociacoesEmit="associar"
            @change="atualizarListas($event)"
          />
        </div>
      </div> 
    </div>
    <SGPLoadingComponent v-if="loadingTarefasMobilidades" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MobilidadeMetodoAssociacaoPage',

  data () {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created () {
    await this.recuperarTarefaMobilidadePorId(this.$route.params.ctrl_tarefa_mobilidade);
    await this.listarMetodos();
    await this.listarAcoesIntegradasPorTarefaMobilidade(this.$route.params.ctrl_tarefa_mobilidade);

    this.atualizarListaDeDadosAssociadosENaoAssociados();
  },

  computed: {
    ...mapGetters('ctrlTarefasMobilidades', [
      'tarefaMobilidadeSelecionada',
      'loadingTarefasMobilidades',
      'listaDeMetodosAssociados'
    ]),    
    ...mapGetters('ctrlMetodos', ['listaDeMetodos']),

    itensAssociados () {
        if( typeof this.listaDeMetodosAssociados.ctrl_tarefa_mobilidade_acao_integrada != 'undefined'){
          return this.listaDeMetodosAssociados.ctrl_tarefa_mobilidade_acao_integrada.map(item => {
            return {
              id: item.ctrl_metodo.id,
              descricao: item.ctrl_metodo.metodo,
              selecionado: false
            }
          });
        }
        return [];
    },

    itensDisponiveis () {
      const listaDeItemsAssociados = this.itensAssociados.map(item => item.id);

      return this.listaDeMetodos.filter(item => {    
        return (!listaDeItemsAssociados.includes(item.id)) && item.deleted_at === null;
      }).map(item => {
        return {
          id: item.id,
          descricao: item.metodo,
          selecionado: false
        }
      })
    }
  },

  methods: {
    ...mapActions('ctrlMetodos', [ 'listarMetodos']),
    ...mapActions('ctrlTarefasMobilidades', [
      'recuperarTarefaMobilidadePorId',
      'listarAcoesIntegradasPorTarefaMobilidade',
      'associarAcoesIntegradas'
    ]),

    atualizarListas(event) {
      if(typeof event == 'undefined'){
        return false;
      }
      this.atualizarListaDeDadosAssociadosENaoAssociados();
    },
    
    atualizarListaDeDadosAssociadosENaoAssociados () {
      this.listaDadosAssociados = this.itensAssociados
      this.listaDadosDisponiveis = this.itensDisponiveis
    },

    async associar (value) {
      const listaIdsAssociados = value.listaAssociados.map((item, index) => {
        return {ctrl_metodo_id: item.id, ordem: (index + 1)}
      });

      const listaIdsDesassociados = value.listaDisponivel.map(item => {
        return item.id
      });

      const payload = {
        ctrl_tarefa_mobilidade_id: this.$route.params.ctrl_tarefa_mobilidade,
        metodosParaAssociar: listaIdsAssociados,
        metodosParaDesassociar: listaIdsDesassociados
      }
    
      await this.associarAcoesIntegradas(payload);
    }
  },

  watch: {
    itensDisponiveis(){
      this.atualizarListaDeDadosAssociadosENaoAssociados(); 
    }
  },
}
</script>
